export const CARDINAL_DIRECTION_NAME_TO_ABBREV = {
    NORTH: "N", NORTHEAST: "NE", EAST: "E", SOUTHEAST: "SE",
    SOUTH: "S", SOUTHWEST: "SW", WEST: "W", NORTHWEST: "NW",
};
export const COMPASS_GRID = [["NW", "N", "NE"], ["W", null, "E"], ["SW", "S", "SE"]];
export const CARDINAL_DIRECTIONS = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];

export function normalizeCardinalDirections(dirs) {
    return (dirs ?? []).map((d) => CARDINAL_DIRECTION_NAME_TO_ABBREV[d] ?? d);
}

export function headingToCardinalDirection(heading) {
    heading = ((heading % 360) + 360) % 360;
    if (heading <= 22.5 || heading > 337.5) return "N";
    if (heading <= 67.5) return "NE";
    if (heading <= 112.5) return "E";
    if (heading <= 157.5) return "SE";
    if (heading <= 202.5) return "S";
    if (heading <= 247.5) return "SW";
    if (heading <= 292.5) return "W";
    return "NW";
}

export function getSpanKeyDirections(spanHeading) {
    return new Set([
        headingToCardinalDirection(spanHeading),
        headingToCardinalDirection(spanHeading + 180),
        headingToCardinalDirection(spanHeading + 90),
        headingToCardinalDirection(spanHeading + 270),
    ]);
}

export function defaultAllowedMastHeadings(spanHeading) {
    const keyDirs = getSpanKeyDirections(spanHeading);
    return new Set(CARDINAL_DIRECTIONS.filter((d) => keyDirs.has(d)));
}
